import { render, staticRenderFns } from "./ReferralReward.vue?vue&type=template&id=511f680c&"
import script from "./ReferralReward.vue?vue&type=script&lang=js&"
export * from "./ReferralReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports